import type { WhoAmIResponse } from '@carculate/api-client';

/**
 * Story `fe-be-verzekeraar-rol-scope-worklist` (2026-06-29) — de canonieke
 * verzekeraar-rol-claim (lowercase, conform de glasadmin/hoofdkantoor-conventie;
 * `Array.includes` is case-sensitive). De BE zet deze claim in `session.Roles`
 * (via `RoleClaimMapper.VerzekeraarClaim`) wanneer de ingelogde gebruiker de
 * aparte `GlasVerzekeraar`-`WF_Role` heeft.
 */
export const VERZEKERAAR_ROLE = 'verzekeraar';

/**
 * Of de ingelogde gebruiker een verzekeraar is (aparte, ingeperkte rol).
 * Bepaalt de **kale chrome** (alleen "Te beoordelen", geen app-switcher/zoek/
 * recent/bel) + de verzekeraar-worklist als landing. Fail-closed: `null`/geen
 * rol-set → `false` (geen verzekeraar-ervaring).
 */
export function isInsurerUser(user: WhoAmIResponse | null | undefined): boolean {
    return !!user && Array.isArray(user.roles) && user.roles.includes(VERZEKERAAR_ROLE);
}

/**
 * Of de ingelogde gebruiker een **hersteller** is: een hoofdkantoor- of
 * vestigings-medewerker (`userContextType ∈ {RepairerHQ, RepairerLocation}`).
 * Bewust NIET op `repairerId` gebaseerd — een System-user kan óók een
 * `repairerId` dragen (de BE geeft System voorrang), en System/RegularUser
 * mogen géén hersteller-only functie zien.
 *
 * Spiegelt de BE-gate `LedgersController.IsRepairerContext`. Fail-closed:
 * `null`/onbekend context-type → `false`. Gebruikt door de hersteller-only
 * tab-zichtbaarheid (`Tab.requiresRepairerContext`) én de route-gate
 * (`<ProtectedRoute repairersOnly>`).
 */
export function isRepairerUser(user: WhoAmIResponse | null | undefined): boolean {
    return (
        !!user &&
        (user.userContextType === 'RepairerHQ' ||
            user.userContextType === 'RepairerLocation')
    );
}
